/**
 * Enhanced Ecommerce Tracking for Google Analytics 4
 * Tracks: impressions, clicks, add-to-cart, checkout, purchase
 */

(function() {
  'use strict';

  // Wait for gtag to be available
  function waitForGtag(callback) {
    if (typeof gtag !== 'undefined') {
      callback();
    } else {
      setTimeout(function() { waitForGtag(callback); }, 100);
    }
  }

  // Track product impressions on collection/search pages
  function trackProductImpressions() {
    const productCards = document.querySelectorAll('.card-product, [data-product-id]');

    if (productCards.length === 0) return;

    const items = [];
    productCards.forEach(function(card, index) {
      const productId = card.getAttribute('data-product-id') || card.querySelector('[data-product-id]')?.getAttribute('data-product-id');
      const productTitle = card.querySelector('.card__heading')?.textContent.trim();
      const productPrice = card.querySelector('.price-item')?.textContent.replace(/[^0-9.]/g, '');

      if (productId && productTitle) {
        items.push({
          item_id: productId,
          item_name: productTitle,
          price: parseFloat(productPrice) || 0,
          index: index,
          item_list_name: document.title
        });
      }
    });

    if (items.length > 0) {
      waitForGtag(function() {
        gtag('event', 'view_item_list', {
          items: items
        });
      });
    }
  }

  // Track product clicks
  function trackProductClicks() {
    const productLinks = document.querySelectorAll('a[href*="/products/"], .card-product a, .product-card a');

    productLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const card = this.closest('.card-product, [data-product-id]');
        if (!card) return;

        const productId = card.getAttribute('data-product-id');
        const productTitle = card.querySelector('.card__heading')?.textContent.trim();
        const productPrice = card.querySelector('.price-item')?.textContent.replace(/[^0-9.]/g, '');

        if (productId && productTitle) {
          waitForGtag(function() {
            gtag('event', 'select_item', {
              items: [{
                item_id: productId,
                item_name: productTitle,
                price: parseFloat(productPrice) || 0
              }]
            });
          });
        }
      });
    });
  }

  // Track "view_item" on product pages
  function trackProductView() {
    if (window.location.pathname.includes('/products/')) {
      const productId = document.querySelector('.ga-product-id')?.value;
      const productTitle = document.querySelector('.ga-product-title')?.value;
      const productPrice = document.querySelector('.ga-product-price')?.value;

      if (productId && productTitle) {
        waitForGtag(function() {
          gtag('event', 'view_item', {
            currency: 'USD',
            value: parseFloat(productPrice) || 0,
            items: [{
              item_id: productId,
              item_name: productTitle,
              price: parseFloat(productPrice) || 0
            }]
          });
        });
      }
    }
  }

  // Track "add_to_cart" events
  function trackAddToCart() {
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (form.getAttribute('data-type') === 'add-to-cart-form') {
        const productId = form.querySelector('.ga-product-id')?.value;
        const productTitle = form.querySelector('.ga-product-title')?.value;
        const productPrice = form.querySelector('.ga-product-price')?.value;
        const quantity = form.querySelector('input[name="quantity"]')?.value || 1;

        if (productId && productTitle) {
          waitForGtag(function() {
            gtag('event', 'add_to_cart', {
              currency: 'USD',
              value: parseFloat(productPrice) * parseInt(quantity),
              items: [{
                item_id: productId,
                item_name: productTitle,
                price: parseFloat(productPrice),
                quantity: parseInt(quantity)
              }]
            });
          });
        }
      }
    });
  }

  // Track "begin_checkout" when user goes to checkout
  function trackBeginCheckout() {
    const checkoutButtons = document.querySelectorAll('button[name="checkout"], a[href*="/checkout"]');

    checkoutButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        // Try to get cart data
        fetch('/cart.js')
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            const items = cart.items.map(function(item) {
              return {
                item_id: item.product_id.toString(),
                item_name: item.product_title,
                price: item.price / 100,
                quantity: item.quantity
              };
            });

            waitForGtag(function() {
              gtag('event', 'begin_checkout', {
                currency: 'USD',
                value: cart.total_price / 100,
                items: items
              });
            });
          })
          .catch(function(error) {
            // Cart data fetch failed silently
          });
      });
    });
  }

  // Track "remove_from_cart"
  function trackRemoveFromCart() {
    document.addEventListener('click', function(e) {
      const removeButton = e.target.closest('.cart-item__remove, [data-cart-item-remove]');
      if (!removeButton) return;

      const cartItem = removeButton.closest('.cart-item, [data-cart-item]');
      if (!cartItem) return;

      const productTitle = cartItem.querySelector('.cart-item__name, .cart-item__title')?.textContent.trim();
      const productPrice = cartItem.querySelector('.cart-item__price')?.textContent.replace(/[^0-9.]/g, '');
      const quantity = cartItem.querySelector('.cart-item__quantity')?.value || 1;

      if (productTitle) {
        waitForGtag(function() {
          gtag('event', 'remove_from_cart', {
            currency: 'USD',
            value: parseFloat(productPrice) * parseInt(quantity),
            items: [{
              item_name: productTitle,
              price: parseFloat(productPrice),
              quantity: parseInt(quantity)
            }]
          });
        });
      }
    });
  }

  // Initialize all tracking
  function init() {
    // Track based on page type
    if (document.querySelector('.collection, .search-page')) {
      trackProductImpressions();
      trackProductClicks();
    }

    if (window.location.pathname.includes('/products/')) {
      trackProductView();
    }

    // Universal tracking
    trackAddToCart();
    trackBeginCheckout();
    trackRemoveFromCart();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
